export default __webpack_public_path__ + "static/media/886.d27bcb96.png";